/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Scope_NoteInputs */



/**
* | output |
* | --- |
* | "Applies to your normal chats only — not to agents, the Teams bot, or automated workflows." |
*
* @param {Memory_Scope_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_scope_note = /** @type {((inputs?: Memory_Scope_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Scope_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gilt nur für normale Chats – nicht für Agenten, den Teams-Bot oder automatisierte Workflows.")
	return /** @type {LocalizedString} */ ("Applies to your normal chats only — not to agents, the Teams bot, or automated workflows.")
});